import { addToChainAfter, ApiHandler, HasOnComplete, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    updateShipTo as updateShipToApi,
    UpdateShipToApiParameter,
} from "@insite/client-framework/Services/CustomersService";
import {
    chain,
    DispatchCompleteLoadShipTo,
    SendDataToApi,
} from "@insite/client-framework/Store/Data/ShipTos/Handlers/UpdateShipTo";

import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<UpdateShipToApiParameter & HasOnComplete, ShipToModel>;

export const XngSendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await updateShipToApi(props.apiParameter);
        (props as any).onError = false;
    } catch (e) {
        (props as any).onError = true;
    }
};

export const ExecuteOnCompleteCallback: HandlerType = props => {
    props.parameter.onComplete?.((props as any).onError);
};

export const XngDispatchCompleteLoadShipTo: HandlerType = props => {
    if (!(props as any).onError) {
        props.dispatch({
            type: "Data/ShipTos/CompleteLoadShipTo",
            model: props.apiResult,
        });
    }
};

addToChainAfter(chain, DispatchCompleteLoadShipTo, ExecuteOnCompleteCallback);
replaceInChain(chain, SendDataToApi, XngSendDataToApi);
replaceInChain(chain, DispatchCompleteLoadShipTo, XngDispatchCompleteLoadShipTo);
